import {NgModule, Pipe, PipeTransform} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'translateMultiple',
    standalone: false
})
export class TranslateMultiplePipe implements PipeTransform {
    constructor(private translate: TranslateService) {}

    transform(value: string, originalSeparator: string = '|', newSeparator: string = ', '): string {
        if (!value) return '';

        return value
            .split(originalSeparator)
            .map(key => this.translate.instant(key.trim()))
            .join(newSeparator);
    }
}
@NgModule({
    declarations: [TranslateMultiplePipe],
    exports: [TranslateMultiplePipe],
})
export class TranslateMultiplePipeModule {}
